export const coveredHeaderOptions = [
  { label: 'Add Covered Item', value: 'Add Covered Item', callback: 'onRowEdit' },
  { label: 'Multiple Entry', value: 'Multiple Entry', callback: 'onRowUpdate' }
];
